import React, { createContext, useContext, useMemo } from 'react';
import { translations, supportedLanguages, defaultLanguage } from '../i18n/translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  // Always use Italian
  const currentLang = defaultLanguage;
  
  // Get translations for Italian
  const t = useMemo(() => {
    return translations[currentLang];
  }, [currentLang]);
  
  const value = {
    lang: currentLang,
    t,
    supportedLanguages
  };
  
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
